module.exports = __webpack_public_path__ + "static/media/workingmemory-words-intronn.d3771a0d.mp3";